export default "__VITE_ASSET__44093f72__"